@if (arbetsorder && maskinlagLoaded) {
  <div>
    <div class="row">
      <rask-selector
        aid="maskinlagValjMaskinlag"
        class="col-8"
        [label]="texts.valjMaskinlag"
        [ngModel]="selectedMaskinlag"
        (ngModelChange)="maskinlagSelectionChanged($event)"
        [disabled]="changeMaskinlagDisabled || !canEdit()"
        [values]="selectedMinaMaskinlag"
        [canDelete]="canDelete()"
        [viewFormatter]="maskinlagViewFormatter"
        [showHeader]="true">
        <ng-container header>
          <a class="ps-1" href="javascript: void(0)" (click)="openMinaMaskinlag()">{{texts.minaMaskinlag}}</a>
        </ng-container>
      </rask-selector>
    </div>
    @if (!egetMaskinlag) {
      <div class="row">
        <rask-input
          [readonly]="true"
          [ngModel]="selectedEntreprenorNamn"
          label="Ansvarig Entreprenör"
          class="col-11 pe-0">
        </rask-input>
        @if (entreprenorSaknas) {
          <div class="messages ps-3 pe-3">
            <small class="text-info">
              {{ texts.entreprenorSaknas }}
            </small>
          </div>
        }
      </div>
    }
    @if (showMaskinoperationInfo) {
      <div>
        <div class="d-flex align-items-end">
          <div class="flex-grow-1 me-3">
            <rask-input
              [readonly]="true"
              [ngModel]="ansvarigAvverkningledare"
              label="Ansvarig för avverkning"
              class="p-0">
            </rask-input>
          </div>
          <rask-button color="tertiary" [disabled]="!canEdit()" (click)="setInloggadAnsvarigAvverkningsledare()">Sätt mig som ansvarig</rask-button>
        </div>
        <div class="row">
          <rask-button aid="findNextAvailableSpaceInSchedule" [disabled]="isProduktionGodkand || !canEdit()" color="secondary"
            (click)="findNextAvailableSpaceInSchedule()">
            {{texts.findNextAvailableSpaceInSchedule}}
          </rask-button>
        </div>
        @if (isAvverkning) {
          <div class="row">
            <div class="col-4 ps-0 pe-0">
              <rask-datepicker
                aid="maskinlagSkordningStartDatum"
                class="col-11 pe-0"
                [label]="texts.skordningStart"
                [(ngModel)]="skordningStartdatum"
                [onlyMonths]="false"
                [disabled]="!canEdit()">
              </rask-datepicker>
            </div>
            <rask-datepicker
              aid="maskinlagSkordningSlutDatum"
              class="col-4"
              minDate="{{skordningStartdatum}}"
              [(ngModel)]="skordningSlutdatum"
              [onlyMonths]="false"
              [disabled]="!canEdit()">
            </rask-datepicker>
            <rask-input-number
              class="col-2"
              [label]="texts.fordrojningSkotning"
              [disabled]="changeFordrojningSkotningDisabled || !canEdit()"
              [(ngModel)]="angivenFordrojningSkotning"
              [min]="0"
              [placeholder]="fordrojningSkotning">
            </rask-input-number>
          </div>
        }
        <div class="row">
          <div class="col-4 ps-0 pe-0">
            <rask-input
              [readonly]="true"
              [ngModel]="skotningStartdatum"
              [label]="texts.skotningStart"
              class="col-11 pe-0">
            </rask-input>
          </div>
          <rask-input
            [readonly]="true"
            [ngModel]="skotningSlutdatum"
            label=" "
            class="col-4">
          </rask-input>
          <rask-input [readonly]="true" class="col-4" [label]="texts.skotningsavstand" [ngModel]="skotningsavstand">
          </rask-input>
        </div>
        @if (isAvverkning) {
          <div class="row">
            <rask-input [readonly]="true" class="col-4" [label]="texts.antalDagarTotalt" [ngModel]="antalSkordardagar">
            </rask-input>
            <rask-input [readonly]="true" class="col-4" [label]="texts.varavArbetsdagar"
            [ngModel]="antalSkordarArbetsdagar"></rask-input>
            <rask-input  [readonly]="true" class="col-4" [label]="texts.arbetstimmarPerDag"
            [ngModel]="maskinlagTimmarPerDag"></rask-input>
          </div>
          <div class="row">
            <rask-input [readonly]="true" class="col-4" [label]="texts.planeradVolym" [ngModel]="planeradVolym">
            </rask-input>
            <rask-input [readonly]="true" class="col-4" [label]="texts.totaltUtfall" [ngModel]="utfall"></rask-input>
            <rask-input [readonly]="true" class="col-4" [label]="texts.utfallPerPlanerad" [ngModel]="utfallPerPlanerad">
            </rask-input>
          </div>
          <div class="row">
            <div class="row col-12">
              <b class="ps-2 pt-3">{{texts.skordadPrestationPerDag}}</b>
            </div>
            <rask-input [readonly]="true" class="col-3" [label]="texts.maskinregister" [ngModel]="prestationM3fubTimme">
            </rask-input>
            <rask-input-number [disabled]="changeJusteradPrestationDisabled || !canEdit()" [min]="1" class="col-2"
            [label]="texts.justerad" [(ngModel)]="justeradPrestation"></rask-input-number>
            <rask-input [readonly]="true" class="col-2" [label]="texts.avrundad" [ngModel]="avrundat"></rask-input>
            <rask-input [readonly]="true" class="col-2" [label]="texts.utfallPerArbetsdag" [ngModel]="utfallPerArbetsdag">
            </rask-input>
            <rask-input [readonly]="true" class="col-2" [label]="texts.korrektion" [ngModel]="korrektion"></rask-input>
          </div>
        } @else {
          <div class="row">
            <rask-input [readonly]="true" class="col-4" [label]="texts.antalDagarTotalt" [ngModel]="antalSkotningdagar">
            </rask-input>
            <rask-input [readonly]="true" class="col-4" [label]="texts.varavArbetsdagar"
            [ngModel]="antalSkotningArbetsdagar"></rask-input>
          </div>
        }
      </div>
    }
    <div class="row ps-3 pt-2">
        <label class="csrLabel col-3"><a href="{{linkToMaskinregister}}"
                target="_blank">{{texts.lankTillMaskinregister}}</a></label>
        <rask-info class="col-9">{{texts.fomaInfo}}</rask-info>
    </div>
  </div>
}
